import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb, PageHeader } from 'antd';
import { isEmpty } from 'lodash-es';
import { useContext, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouterContext } from '../AppLayout';
import { DocumentTitle, FreeAnchorLayout } from '../components';
import { FreeFooterToolbar } from '../components/FreeFooterToolbar';
import { useRouteTitle, useSharedGlobalState } from '../hooks';
import { useMatchMenuItem } from './hooks/useMatchMenuItem';
import { findFirstChild } from './hooks/findFirstChild';
export const PageLayout = ({ title: propsTitle, breadcrumb = false, children, footer, isScrollTop, anchor, ...pageProps }) => {
    const searchBreadcrumb = new URLSearchParams(window.location.search).get('breadcrumb');
    const matchMenuItem = useMatchMenuItem();
    const { routers } = useContext(RouterContext);
    const { resourceListMap } = useSharedGlobalState();
    const navigate = useNavigate();
    const breadcrumbIds = [
        ...(matchMenuItem?.parentIds || []),
        matchMenuItem?.id,
    ].filter(Boolean);
    const breadcrumbMatchs = breadcrumbIds
        .map((id) => resourceListMap[id])
        .filter(Boolean);
    const title = useRouteTitle({ routesConfig: routers, serverPageConfig: matchMenuItem });
    const hasFooter = !isEmpty(footer);
    const breadcrumbRender = () => {
        return (_jsx(Breadcrumb, { children: breadcrumbMatchs.map((match, index) => {
                return (_jsx(Breadcrumb.Item, { onClick: (e) => {
                        if (!match.isLeaf) {
                            const firstChild = findFirstChild(match.children);
                            if (firstChild && firstChild.key) {
                                navigate(firstChild.key);
                            }
                        }
                    }, children: match?.meta?.title }, match.id + index));
            }) }));
    };
    const renderHeader = () => {
        if (breadcrumb || searchBreadcrumb === 'hide') {
            return {};
        }
        if (searchBreadcrumb === 'breadcrumb') {
            return {
                breadcrumbRender,
            };
        }
        if (searchBreadcrumb === 'title') {
            return {
                title: propsTitle ? propsTitle : title,
            };
        }
        useLayoutEffect(() => {
            if (isScrollTop !== false) {
                document.documentElement.scrollTo(0, 0);
            }
        }, [isScrollTop]);
        return {
            title: propsTitle ? propsTitle : title,
            breadcrumbRender
        };
    };
    return (_jsxs(_Fragment, { children: [_jsx(DocumentTitle, {}), _jsx(PageHeader, { style: hasFooter ? { minHeight: 'calc(100% - 48px)', paddingBottom: 0 } : { minHeight: '100%' }, ...renderHeader(), ...pageProps, children: anchor ? _jsx(FreeAnchorLayout, { id: 'content-layout', ...anchor, children: children }) : _jsx("div", { id: 'content-layout', children: children }) }), hasFooter ? _jsx(FreeFooterToolbar, { children: footer }) : null] }));
};
